/* loading-dot-wave.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./loading-dot-wave.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useCallback, useEffect, useRef } from 'react';
var loadingDotWaveWrapperStyles = null;
export var LoadingDotWave = function LoadingDotWave(_ref) {
  var width = _ref.width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 15 : _ref$height;
  var canvasRef = useRef(null);
  var dotsRef = useRef([]);
  var animationRef = useRef();
  var timeRef = useRef(0);

  // Calculate number of dots based on consistent spacing
  var dotRadius = 2;
  var idealSpacing = width < 18 ? 6 : 8.4;
  var availableWidth = width - dotRadius * 2;
  var maxDots = Math.floor(availableWidth / idealSpacing) + 1;
  var dotCount = Math.max(2, maxDots);

  // Initialize dots
  var initDots = useCallback(function () {
    var dots = [];
    var centerY = height / 2;

    // Calculate available space for dots (subtract padding for dot radius on both sides)
    var availableWidth = width - 1 - dotRadius * 2;
    var spacing = dotCount > 1 ? availableWidth / (dotCount - 1) : 0;
    for (var i = 0; i < dotCount; i++) {
      dots.push({
        x: dotRadius + i * spacing,
        // Start from dotRadius to avoid cutoff
        y: centerY,
        baseY: centerY,
        phase: i / dotCount * Math.PI * 2,
        size: dotRadius
      });
    }
    return dots;
  }, [dotCount, height, width]);

  // Gradient for dots
  var createGradient = useCallback(function (ctx, x) {
    var gradient = ctx.createRadialGradient(x, 0, 0, x, 0, dotRadius);

    // Calculate position along the available width for color interpolation
    var availableWidth = width - dotRadius * 2;
    var adjustedX = x - dotRadius;
    var position = availableWidth > 0 ? Math.max(0, Math.min(1, adjustedX / availableWidth)) : 0;

    // Create linear gradient with colors: #0065FF → #0267FF → #BF63F3 → #FFA900
    var colors = [{
      r: 0,
      g: 101,
      b: 255
    },
    // #0065FF
    {
      r: 2,
      g: 103,
      b: 255
    },
    // #0267FF
    {
      r: 191,
      g: 99,
      b: 243
    },
    // #BF63F3
    {
      r: 255,
      g: 169,
      b: 0
    } // #FFA900
    ];
    var color;
    if (position <= 0.33) {
      // Interpolate between #0065FF and #0267FF
      var localPos = position / 0.33;
      var color1 = colors[0];
      var color2 = colors[1];
      color = {
        r: Math.floor(color1.r + (color2.r - color1.r) * localPos),
        g: Math.floor(color1.g + (color2.g - color1.g) * localPos),
        b: Math.floor(color1.b + (color2.b - color1.b) * localPos)
      };
    } else if (position <= 0.66) {
      // Interpolate between #0267FF and #BF63F3
      var _localPos = (position - 0.33) / 0.33;
      var _color = colors[1];
      var _color2 = colors[2];
      color = {
        r: Math.floor(_color.r + (_color2.r - _color.r) * _localPos),
        g: Math.floor(_color.g + (_color2.g - _color.g) * _localPos),
        b: Math.floor(_color.b + (_color2.b - _color.b) * _localPos)
      };
    } else {
      // Interpolate between #BF63F3 and #FFA900
      var _localPos2 = (position - 0.66) / 0.34;
      var _color3 = colors[2];
      var _color4 = colors[3];
      color = {
        r: Math.floor(_color3.r + (_color4.r - _color3.r) * _localPos2),
        g: Math.floor(_color3.g + (_color4.g - _color3.g) * _localPos2),
        b: Math.floor(_color3.b + (_color4.b - _color3.b) * _localPos2)
      };
    }
    gradient.addColorStop(0, "rgb(".concat(color.r, ", ").concat(color.g, ", ").concat(color.b, ")"));
    gradient.addColorStop(1, "rgb(".concat(Math.floor(color.r * 0.8), ", ").concat(Math.floor(color.g * 0.8), ", ").concat(Math.floor(color.b * 0.8), ")"));
    return gradient;
  }, [width]);

  // Animation loop
  var animate = useCallback(function () {
    var canvas = canvasRef.current;
    if (!canvas) {
      return;
    }
    var ctx = canvas.getContext('2d');
    if (!ctx) {
      return;
    }

    // Clear canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Update time
    timeRef.current += 0.08;

    // Update and draw dots
    dotsRef.current.forEach(function (dot) {
      // Calculate wave motion
      var waveOffset = Math.sin(timeRef.current + dot.phase);
      dot.y = dot.baseY + waveOffset;

      // Apply gradient to this dot
      var gradient = createGradient(ctx, dot.x);

      // Draw dot
      ctx.beginPath();
      ctx.arc(dot.x, dot.y, dot.size, 0, Math.PI * 2);
      ctx.fillStyle = gradient;
      ctx.fill();

      // Add subtle shadow
      ctx.shadowColor = 'rgba(0, 0, 0, 0.1)';
      ctx.shadowBlur = 2;
      ctx.shadowOffsetY = 1;
    });

    // Continue animation
    animationRef.current = requestAnimationFrame(animate);
  }, [canvasRef, createGradient]);

  // Initialize dots when width changes
  useEffect(function () {
    dotsRef.current = initDots();
  }, [width, dotCount, height, initDots]);

  // Set up canvas and start animation
  useEffect(function () {
    var canvas = canvasRef.current;
    if (!canvas) {
      return;
    }

    // Set canvas dimensions
    canvas.width = width;
    canvas.height = height;

    // Start animation
    animationRef.current = requestAnimationFrame(animate);

    // Cleanup
    return function () {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [animate, height, width]);
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_kqswstnw _154imgjw"])
  }, /*#__PURE__*/React.createElement("canvas", {
    ref: canvasRef,
    width: width,
    height: height
  }));
};